/* istanbul ignore file */

import React from 'react';

import { useRoutes } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import {
    CenterCircularProgress,
    ModalProvider,
    VerboseProvider,
    AvatarUrlProvider,
} from '@europrocurement/flexy-components';
import { UseKeycloakService } from '@europrocurement/l2d-keycloak';
import { useLoadingStatus } from '@europrocurement/l2d-hooks';

import { APIS_ENUM, getBasePathFromApiName, INIT_STATE } from '@europrocurement/l2d-domain';

import { WebsocketProvider } from '@europrocurement/l2d-websocket';
import L2DTheme from './Theme';
import Router from './router/router';
import 'react-grid-layout/css/styles.css';

const App = function () {
    const routing = useRoutes(Router);
    const kc = UseKeycloakService();
    const theme = L2DTheme();

    const { loading } = useLoadingStatus({ checkReady: () => kc.isInitialized() });

    return (
        <WebsocketProvider
            baseWebsocketUrl={
                getBasePathFromApiName(APIS_ENUM.WS_MESSAGERIE) || INIT_STATE.api.wsMessagerie
            }
        >
            <AvatarUrlProvider>
                <VerboseProvider>
                    <ModalProvider>
                        <ThemeProvider theme={theme}>
                            {!loading ? routing : <CenterCircularProgress />}
                            <CssBaseline />
                        </ThemeProvider>
                    </ModalProvider>
                </VerboseProvider>
            </AvatarUrlProvider>
        </WebsocketProvider>
    );
};

export default App;
